module.exports = __webpack_public_path__ + "static/media/mud_logo_with_blurb.616ac47c.jpg";